export const MIN_VOLUME_DELTA_FOR_SPEECH = 12;

export default function didSaySomething(volumeStats, forcePass = false){
    const { maxVolume, minVolume: rawMin } = volumeStats;
    // Sanitize -Infinity for minVolume to -100 dB (very quiet)
    const minVolume = rawMin === -Infinity ? -100 : rawMin;
    const delta = maxVolume - minVolume;
    const result = forcePass || delta > MIN_VOLUME_DELTA_FOR_SPEECH;
    return result;
}